import { render, staticRenderFns } from "./TeamAdd.vue?vue&type=template&id=01fc6b73&scoped=true"
import script from "./TeamAdd.vue?vue&type=script&lang=js"
export * from "./TeamAdd.vue?vue&type=script&lang=js"
import style0 from "./TeamAdd.vue?vue&type=style&index=0&id=01fc6b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc6b73",
  null
  
)

export default component.exports